
import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { BehaviorSubject } from 'rxjs';


@Injectable()
export class MainNavService {

  constructor() { }

  private mainnavAnnouncedSource = new Subject<{}>();
  // Observable string streams
  mainnavAnnounced$ = this.mainnavAnnouncedSource.asObservable();
  // Service message commands
  announceMainNav(queryparms: {  }) {
    this.mainnavAnnouncedSource.next(queryparms);
  }

}
